import {
  GetBusinessUnitWithId,
  SET_BUSINESS_UNIT_WITH_ID,
  SetBusinessUnitWithId,
  SET_ELEMENT_CREATIVE_AI,
  SetElementCreativeAi,
  SET_AI_GROUP_LIST,
  SetAiGroupListing,
  NAVIGATE_VARIANT,
  NavigateVariant,
  GET_ELEMENT_CREATIVE_AI,
  GetElementCreativeAi,
  GENERATE_LEVERS,
  GenerateLevers,
  SetGenerateLevers,
  SET_GENERATE_LEVERS,
  SetAllBusinessUnitList,
  SET_ALL_BUSINESS_UNIT_LIST,
  SET_AD_ADSET_FIELD_LIST,
  SetAdAdSetFieldList,
  TOGGLE_CREATIVE_ANIMATER,
  ToggleCreativeAnimater,
  GET_BUSINESS_UNIT_WITH_ID,
  GET_ELEMENT_RESULT_METRICS,
  GetElementResultMetrics,
  SET_ELEMENT_RESULT_METRICS,
  SetElementResultMetrics,
} from "../../../../types/CreativeAI/Facebook/Main/Main";

const initialState = {
  variantWithId: null,
  elementCreativeAi: { loading: false },
  AIGroupListing: [],
  navigateVariant: false,
  defaultLevers: [],
  AllBusinessUnitList: [],
  adAdSetFieldList: {},
  currentPage: 0,
  toggleCreativeAnimater: false,
  fetchingBusinessUnit: false,
  resultMetrics: { isLoading: true, data: {} },
};

const MainReducer = (
  state = initialState,
  action:
    | GetBusinessUnitWithId
    | SetBusinessUnitWithId
    | SetElementCreativeAi
    | SetAiGroupListing
    | NavigateVariant
    | GetElementCreativeAi
    | SetGenerateLevers
    | SetAllBusinessUnitList
    | SetAdAdSetFieldList
    | ToggleCreativeAnimater
    | GetElementResultMetrics
    | SetElementResultMetrics
) => {
  switch (action.type) {
    case GET_BUSINESS_UNIT_WITH_ID: {
      let fetchingBusinessUnit = state.fetchingBusinessUnit;
      if (!action.payload?.callback) {
        fetchingBusinessUnit = true;
      }
      return {
        ...state,
        fetchingBusinessUnit,
      };
    }

    case SET_BUSINESS_UNIT_WITH_ID: {
      return {
        ...state,
        variantWithId: action.payload,
        fetchingBusinessUnit: false,
      };
    }
    case GET_ELEMENT_CREATIVE_AI: {
      let elementCreativeAi = state.elementCreativeAi;
      if (!action.payload?.callback) {
        elementCreativeAi = { loading: true };
      }
      return {
        ...state,
        elementCreativeAi,
      };
    }
    case SET_ELEMENT_CREATIVE_AI: {
      return {
        ...state,
        loading: false,
        elementCreativeAi: { loading: false, ...action.payload },
      };
    }

    case SET_AD_ADSET_FIELD_LIST: {
      return {
        ...state,
        adAdSetFieldList: action.payload,
      };
    }
    case SET_AI_GROUP_LIST: {
      return {
        ...state,
        AIGroupListing: action.payload,
      };
    }
    case NAVIGATE_VARIANT: {
      return {
        ...state,
        navigateVariant: action.payload,
      };
    }
    case SET_GENERATE_LEVERS: {
      return {
        ...state,
        defaultLevers: action.payload,
      };
    }
    case SET_ALL_BUSINESS_UNIT_LIST: {
      return {
        ...state,
        AllBusinessUnitList: action.payload,
        readyToUseBUs: action.payload.filter(
          (bu: any) => bu.status === "readyToUse"
        ),
      };
    }
    case TOGGLE_CREATIVE_ANIMATER: {
      return { ...state, toggleCreativeAnimater: action.payload };
    }
    case GET_ELEMENT_RESULT_METRICS: {
      return {
        ...state,
        resultMetrics: { isLoading: true, data: {} },
      };
    }
    case SET_ELEMENT_RESULT_METRICS: {
      return {
        ...state,
        resultMetrics: { isLoading: false, data: action.payload },
      };
    }
    default:
      return state;
  }
};
export default MainReducer;
